import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import React from 'react'
import { i18n } from '../../index'
import css from './thumbableServiceDialog.css'
import ThumbableServiceForm from './ThumbableServiceForm'
import type { ThumbableService } from './thumbableServiceTypes'
type ThumbableServiceDialogProps = {
  data: ThumbableService | null | undefined
  stationId?: string
  isOpen: boolean
  onClose: (...args: Array<any>) => any
}

class ThumbableServiceDialog extends React.PureComponent<ThumbableServiceDialogProps> {
  render() {
    const { data, stationId, isOpen, onClose } = this.props
    return (
      <Dialog
        /* disableBackdropClick */
        open={isOpen}
        onClose={onClose}
        aria-labelledby='form-dialog-title'
        className={css.component}
      >
        <DialogTitle id='form-dialog-title'>
          {data && data.id
            ? i18n.t('admin.thumbableServices.editDialogTitle')
            : i18n.t('admin.thumbableServices.createDialogTitle')}
        </DialogTitle>
        <DialogContent>
          <ThumbableServiceForm data={data} stationId={stationId} onSubmit={onClose} onCancel={onClose} />
        </DialogContent>
      </Dialog>
    )
  }
}

export default ThumbableServiceDialog
